import NewinputField from "../../components/NewInput";

type Props = {
  register: any;
  errors: any;
  clearErrors?: any;
  setValue: (name: string, value: any) => void;
  watch: any;
  darkStore: any;
};

const AddRadiusModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  watch,
  darkStore,
}: Props) => {
  const isShared = darkStore?.driverAssignmentType === "SHARED";
  return (
    <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
      <div className="md:w-[550px] sm:w-[450px]  overflow-y-auto space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <NewinputField
            name="deliveryRadius"
            className={!isShared ? "col-span-2" : ""}
            type="number"
            title="Delivery Radius (KM)"
            placeholder="Enter Radius"
            register={register}
            error={errors.deliveryRadius}
            validation={{ required: "Delivery Radius is required" }}
          />

          {darkStore?.driverAssignmentType === "SHARED" && (
            <NewinputField
              name="pickupRadius"
              type="number"
              title="Pickup Radius (KM)"
              placeholder="Enter Pickup Radius"
              register={register}
              error={errors.pickupRadius}
              validation={{ required: "Pickup Radius is required" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddRadiusModal;
